import { createNanoEvents, Emitter } from "nanoevents";

declare global {
  interface Window {
    eventEmitter: Emitter;
  }
}

interface Events {
  set: (name: string, count: number) => void;
  tick: () => void;
}

// Add event emitter to the global window
window.eventEmitter = createNanoEvents<Events>();

// Create an exportable singleton EventBridge that emits/listens to the global event emitter.
const EventBridge = {
  emit(event: string, payload?: {}) {
    if (!window.eventEmitter) return undefined;
    return window.eventEmitter.emit(event, payload);
  },
  on<T>(event: string, callback: (payload: T) => void) {
    if (!window.eventEmitter) return undefined;
    return window.eventEmitter.on(event, callback);
  },
  once<T>(event: string, callback: (payload: T) => void) {
    if (!window.eventEmitter) return undefined;
    const off = window.eventEmitter.on(event, (payload: T) => {
      off();
      callback(payload);
    });
    return off;
  },
  emitFromPhaser(type: string, payload = null) {
    this.emit("phaser:storeon", { type, payload });
  },
  off<T>(event: string, callback?: (payload: T) => void) {
    if (!window.eventEmitter) return;

    if (!callback) {
      delete window.eventEmitter.events[event];
    } else {
      window.eventEmitter.events[event] = (window.eventEmitter.events[event] ?? []).filter((fn) => fn !== callback);
    }
  },
};

export default EventBridge;
